import React from 'react';
import Link from 'next/link';
import Image from "next/image";
import { BASE_ASSETS_URL } from '../../constants/constants';

const BlogImgAndTitle = ({ title, blogImg, imgAlt, authorImg, authorName, dateAndTime }) => {
    return (
        <div className="w-full flex flex-col items-center mb-10 md:mb-0">
            <div className="bg-white rounded-3xl mb-2 w-full text-left">
                <h1 className="text-black text-2xl sm:text-3xl md:text-4xl leading-normal">
                    {title}
                </h1>
            </div>
            <div className='w-full relative flex flex-col items-center'>
                <div className="w-full relative flex py-4 px-2 bg-white items-center gap-3 mb-10">
                    <div className="w-[50px] h-[50px] sm:w-[60px] sm:h-[60px]">
                        <Image
                            src={`${BASE_ASSETS_URL}/boloforms-signature/authors/${authorImg}`}
                            width="10"
                            height="10"
                            className="w-full h-full object-cover rounded-full"
                            alt="BoloForms"
                        />
                    </div>
                    <div className="">
                        <div className="font-bold text-lg text-gray-800">
                            {authorName}
                        </div>
                        <div className="text-gray-600 text-sm">
                            {dateAndTime}
                        </div>
                    </div>
                </div>
                <Image
                    className="max-h-[500px] w-auto rounded-2xl"
                    width={10}
                    height={10}
                    src={`${BASE_ASSETS_URL}/boloforms-signature/comparison/${blogImg}`}
                    alt={imgAlt}
                />
            </div>
        </div>
    )
}

export default BlogImgAndTitle;
